

























































































import Vue from 'vue'
import PlCardBase from './_PLCardBase.vue'
import { getModule } from 'vuex-module-decorators'
import { CompendiumStore } from '@/store'
import { PilotArmor, CompendiumItem, ItemType } from '@/class'
import { flavorID } from '@/io/Generators'

export default Vue.extend({
  name: 'pl-pilot-armor-card',
  components: { PlCardBase },
  props: {
    item: {
      type: Object,
      required: false,
      default: null,
    },
    extended: {
      type: Boolean,
      required: false,
    },
    readonly: {
      type: Boolean,
    },
  },
  data: () => ({
    headers: [
      { text: 'Item', align: 'left', value: 'Name' },
      { text: 'Armor', align: 'center', value: 'Armor' },
      { text: 'HP Bonus', align: 'center', value: 'HPBonus' },
      { text: 'E-Defense', align: 'center', value: 'EDefense' },
      { text: 'Evasion', align: 'center', value: 'Evasion' },
      { text: 'Speed', align: 'center', value: 'Speed' },
      { text: 'Detail', align: 'center', value: 'Detail' },
    ],
  }),
  computed: {
    armor() {
      const attr = this.item.Bonuses.find(b => b.ID === 'pilot_armor')
      return attr ? attr.Value : 0
    },
    hp() {
      const attr = this.item.Bonuses.find(b => b.ID === 'pilot_hp')
      return attr ? attr.Value : 0
    },
    edef() {
      const attr = this.item.Bonuses.find(b => b.ID === 'pilot_edef')
      return attr ? attr.Value : 0
    },
    evasion() {
      const attr = this.item.Bonuses.find(b => b.ID === 'pilot_evasion')
      return attr ? attr.Value : 0
    },
    speed() {
      const attr = this.item.Bonuses.find(b => b.ID === 'pilot_speed')
      return attr ? attr.Value : 0
    },
  },
  methods: {
    equip(item: PilotArmor) {
      this.$emit('equip', this.$_.clone(item))
      this.$refs.base.closeSelector()
    },
    getArmor() {
      const compendium = getModule(CompendiumStore, this.$store)
      return compendium.PilotGear.filter(
        (x: CompendiumItem) => !x.IsHidden && x.ItemType === ItemType.PilotArmor
      )
    },
    fID(template: string): string {
      return flavorID(template)
    },
  },
})
